var SCM = SCM || {};
SCM.PeerReview = (function($) {

    return {
        registerToggle: registerToggle
    };

    function registerToggle() {
        $(document.body).on('click', '.js-peer-review-dropdown-trigger', function (e) {
            e.stopPropagation();
            SCM.Toolbar.closeHypothesis();
            $('.js-peer-review-wrap').toggleClass('expanded');
            $(this).attr('aria-expanded') === 'false' ? $(this).attr('aria-expanded', 'true') : $(this).attr('aria-expanded', 'false');
            $(this).find('i').toggleClass('icon-general-arrow-filled-down icon-general-arrow-filled-up');
        });
    }
})(jQuery);